module.exports = __webpack_public_path__ + "static/media/team.c6a2afd7.png";